import { Component, Input, OnInit } from '@angular/core';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog } from 'app/store/actions/page.action';
import { ContactPrivateNoteComponent } from 'app/dialogs/contact-private-note/contact-private-note.component';
import { IContact } from 'app/store/models/contact.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-message-detail',
  templateUrl: './message-detail.component.html',
  styleUrls: ['./message-detail.component.scss'],
})
export class MessageDetailComponent implements OnInit {
  @Input() messageDetail: string;
  @Input() activityId: number;
  @Input() contactInfo: IContact;
  @Input() messageType: string;
  @Input() messageContent: string;

  privateNoteButtonProperties: Button = {
    color: ButtonColor.BLUE,
    size: ButtonSize.SMALL,
    text: 'Private note',
    onClick: () =>
      this.store.dispatch(
        openDialog({
          dialogData: {
            canClose: true,
            content: ContactPrivateNoteComponent,
            dialogMinWidth: '600px',
            componentData: {
              privateNote: this.messageDetail,
              type: this.messageType,
              note: this.messageContent,
              contactInfo: this.contactInfo,
              activityId: this.activityId,
            },
            title: `${this.contactInfo.firstname} ${this.contactInfo.lastname} Activity Notes:`,
          },
        }),
      ),
  };

  constructor(
    private store: Store<IReducers>,
    private readonly domSanitized: DomSanitizer,
  ) {
  }

  get message(): SafeHtml {
    if (!this.messageDetail) {
      return '';
    }
    return this.domSanitized.bypassSecurityTrustHtml(this.messageDetail);
  }

  ngOnInit() {
  }

  willShowButton(): boolean {
    return ['Phone call', 'Note'].indexOf(this.messageType) !== -1;
  }
}
